import { ToastNotificacao, ToastNotificacaoItem } from 'nemesiselements';
import { TooltipElemento } from 'nemesiselements'

export function setupNemesisElements(app) {
  app.component('ToastNotificacao', ToastNotificacao);
  app.component('ToastNotificacaoItem', ToastNotificacaoItem);
  app.component('TooltipElemento', TooltipElemento);
}
